module.exports = __webpack_public_path__ + "img/connector-types-mobile-fr@2x.9f48c5bc.webp";